export const deliveryNotesFileExtensions = [
  'png',
  'jpeg',
  'pdf',
  'jpg',
  'xlsx',
];
export const deliveryNotesFileExtensionsButton = '.png,.jpeg,.pdf,.jpg,.xlsx';
export const updateDeliveryNotesFileExtensionsButton = '.png,.jpeg,.pdf,.jpg';
export const laboratoryFileExtensions = ['png', 'jpeg', 'pdf', 'jpg'];
export const laboratoryFileExtensionsButton = '.png,.jpeg,.pdf,.jpg';
export const encryptionKey = 'AccionaOCR';
export const concreteTypes = ['delivery', 'deliveryPC'];
